<template>
  <div id="navbar-menu-solutions">
    <div id="navbar-solution-list" :class="listClass()">
      <NavbarMenuSolutionItem
        v-for="appLinkItem in appLinkItemsRef"
        :key="appLinkItem.url"
        :appLinkItem="appLinkItem"
        :domain-id="domainId"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import NavbarMenuSolutionItem from "./NavbarMenuSolutionItem.vue";
import type { AppLinkItem } from "./types";

export default defineComponent({
  name: "NavbarMenuSolutionsPanel",
  components: { NavbarMenuSolutionItem },
  props: {
    appLinkItemsRef: {
      type: Array as PropType<AppLinkItem[]>,
      default: () => [],
    },
    domainId: { type: String, default: () => "" },
  },
  setup() {
    const listClass = (): string => "list-column";

    return {
      listClass,
    };
  },
});
</script>
<style scoped lang="scss">
#navbar-menu-solutions {
  overflow: auto;
  width: 242px;
  border-radius: 8px;
  .navbar-menu-text {
    vertical-align: middle;
    height: 30px;
  }

  #navbar-solution-list {
    &.list-column {
      width: fit-content;
      max-width: 90px * 3 + 20px + 2px;
    }

    // grid layout properties
    display: grid;
    grid-template-rows: 80px;
    grid-template-columns: 70px 70px 70px;
    row-gap: 5px;
    column-gap: 5px;

    min-width: 0;
    padding: 10px;
    margin: 0;
    background-color: white;
    border-radius: 8px;

    @media screen and (max-width: 1000) {
      width: auto;

      &.list-column {
        width: 100%;
      }
    }
  }
}
</style>
